import { render, staticRenderFns } from "./DialogPremium.vue?vue&type=template&id=35407f53"
import script from "./DialogPremium.vue?vue&type=script&lang=ts"
export * from "./DialogPremium.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports